import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import { Icon } from 'shared/components';

import theme from './Stepper.scss';

const propTypes = {
  isStepActive: PropTypes.bool.isRequired,
  isStepDisable: PropTypes.bool.isRequired,
  isStepComplete: PropTypes.bool.isRequired,
  stepId: PropTypes.number.isRequired,
  onStepClick: PropTypes.func.isRequired,
  titleMessage: PropTypes.object.isRequired,

  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

const Step = ({
  isStepActive,
  isStepDisable,
  isStepComplete,
  stepId,
  onStepClick,
  titleMessage,
  intl,
}) => (
  <div
    onClick={ onStepClick }
    className={ classnames(theme.default, {
      [theme.accessible]: !isStepDisable,
      [theme.completed]: isStepComplete && !isStepActive && !isStepDisable,
    }, theme.step) }
  >
    <div className={ theme.index }>
      { (!isStepComplete || isStepActive || isStepDisable) && (
        <span>{ stepId }</span>
      ) }

      { isStepComplete && !isStepActive && !isStepDisable && (
        <Icon name="check" />
      ) }
    </div>

    <div className={ classnames(theme.title, {
      [theme.activeTitle]: isStepActive,
      }) }
    >
      {
        intl.formatMessage({
          ...titleMessage,
        })
      }
    </div>
  </div>
);

Step.propTypes = propTypes;

export default injectIntl(Step);
